import axiosInstance from "./axios";
import { getOrCreateAnonymousId } from "./anonymousId";

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

export const setupPushNotifications = async (restaurantId) => {
  if (!("serviceWorker" in navigator) || !("PushManager" in window)) {
    console.warn("Push messaging is not supported");
    return;
  }

  try {
    const vapidKey = "BEH0Zd7D7wOEXSS3qA3xvK3r7s4s_8uVmM1jDCDAxfgkgqTh7rKCCymKoGPoWjnH7jD_wWIGpn6bGmtMnguXTSk" ||
      process.env.REACT_APP_VAPID_PUBLIC_KEY || "YOUR_GENERATED_VAPID_PUBLIC_KEY";

    const permission = await Notification.requestPermission();
    if (permission !== "granted") {
      console.log("Push notification permission not granted");
      return;
    }

    const registration = await navigator.serviceWorker.register("/sw.js");
    await navigator.serviceWorker.ready;

    let subscription = await registration.pushManager.getSubscription();

    if (!subscription) {
      subscription = await registration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(vapidKey),
      });
    }

    const anonymousId = getOrCreateAnonymousId();

    // Backend me sync karein
    await axiosInstance.post("/api/push/subscribe", {
      subscription,
      anonymousId,
      restaurantId,
    });

    console.log("🔒 Lock-screen Push activated successfully!");
  } catch (error) {
    console.error("Push registration failed:", error);
  }
};